import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import ForgottenPassword from './components/ForgottenPassword';
import ResetPassword from './components/ResetPassword';
//import Chat from './components/Chat';
import Vertex from './components/Vertex';
import Forum from './components/Forum';
import Documents from './components/Documents';
import Logout from './components/Logout';
import Notifications from './components/Notifications';
import NotificationsDetail from './components/NotificationsDetail';
import ForumDetail from './components/ForumDetail';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />}/>
        <Route path="/register" element={<Register />}/>
        <Route path="/forgotten_password" element={<ForgottenPassword />}/>
        <Route path="/reset_password" element={<ResetPassword />}/>
        {/*<Route path="/chat" element={<Chat />}/>*/}
        <Route path="/chat" element={<Vertex />}/>
        <Route path="/notifications" element={<Notifications />}/>
        <Route path="/forum" element={<Forum />}/>
        <Route path="/forum/:discussionId" element={<ForumDetail />} />
        <Route path="/documents" element={<Documents />}/>
        <Route path="/notifications/:notificationId" element={<NotificationsDetail />} />
        <Route path="/logout" element={<Logout />}/>
      </Routes>
    </Router>
  );
}

export default App;